<app-navbar-control></app-navbar-control>

<div class="home-details">

    <app-hero></app-hero>
    <app-beauty-salon-booking-challenges></app-beauty-salon-booking-challenges>
    <app-beauty-salon-booking-workflow></app-beauty-salon-booking-workflow>


    <app-contact-section></app-contact-section>

    <app-footer></app-footer>
</div>